import React from 'react';
import { Button, Col, Media, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import DeleteConfirmButton from '../../common/Buttons/DeleteConfirmButton.jsx';


const PaymentDataItem = ({ id, name, method_display, card_expire, onDelete }) => {
  const handleDelete = () => onDelete(id);

  return <Media className='media-border-bottom my-3'>
    <Media.Body className='flex-wrap'>
      <Row>
        <Col xs={12} md={6}>
          <p>
            <Link to={ id + '/' } title={ gettext('Редактировать данные') } className="font-weight-bold">{ name || '-' }</Link>
            <p className="small text-secondary">
              { method_display }
              { card_expire && ' ' + gettext('действительна до') + ' ' + card_expire }
            </p>
          </p>
        </Col>
        <Col xs={12} md={6} className='text-md-right mb-2 mb-md-0'>
            <Link className='btn btn-sm btn-outline-dark mr-2' to={ id + '/' } title={ gettext('Редактировать') }>
              <i className='icon icon-pencil'></i><span className="d-md-none"> { gettext('Редактировать') }</span>
            </Link>
            <DeleteConfirmButton onDeleteClick={ handleDelete }
                                 withoutTitle={ true }
                                 title={ gettext('Удалить') }/>
        </Col>
      </Row>
    </Media.Body>
    </Media>
};


PaymentDataItem.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string,
  method_display: PropTypes.string.isRequired,
  card_expire: PropTypes.string,
  onDelete: PropTypes.func.isRequired,
};

export default PaymentDataItem;

